import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

export function RDivider() {
    return <Line />;
}

const Line = styled('hr')({
    border: 'none',
    borderTop: `1px solid ${Colors.lightGrey}`,
    margin: 0,
});
